/* */ 
"use strict";
var provider_1 = require('./provider');
function isProviderLiteral(obj) {
  return obj && typeof obj == 'object' && obj.provide;
}
exports.isProviderLiteral = isProviderLiteral;
function createProvider(obj) {
  return new provider_1.Provider(obj.provide, obj);
}
exports.createProvider = createProvider;
